import { schema } from 'normalizr';

const homeMakingTask = new schema.Entity('homeMakingTasks');

export default homeMakingTask;
